import React from 'react';
import { Navigate } from 'react-router-dom';
import { CasdoorSdk } from './CasdoorCallback';
import { getCookie } from '@/shared/services/storage/cookieService';
import { ROUTES } from '@/shared/constants/routes';

const Login: React.FC = () => {
  const access_token = getCookie(import.meta.env.VITE_ACCESS_TOKEN_NAME);
  const refresh_token = getCookie(import.meta.env.VITE_REFRESH_TOKEN_NAME);
  
  if (refresh_token && access_token) {
    return <Navigate to={ROUTES.HOME} />;
  } else {
    window.location.replace(CasdoorSdk.getSigninUrl());
    return null;
  }
};

export default Login;

